<template>
    <div class="mobile-screen" :class="{current:isShown,stay:hasBeenShown}">
        <slot></slot>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data() {
            return {
                isShown: false,
                hasBeenShown: false
            }
        },
        destroyed: function () {

        },
        methods: {
            show(){
                this.isShown = true;
                this.hasBeenShown = true;
            },
            hide(deleteHasBeenShown){
                this.isShown = false;
                if(deleteHasBeenShown === true){
                    this.hasBeenShown = false;
                }
            }
        },
        mounted: function () {

        },
        name: 'MobileScreen',
        props: {
            id: {
                type: String,
                required: true
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ui/MobileScreen.vue